'use strict';

module.exports = function (column) {

    var sortAll = typeof this.opts.sortable == 'boolean' && this.opts.sortable;

    if (sortAll) return true;

    return this.opts.sortable.indexOf(column) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/sortable.js
// module id = 2241
// module chunks = 0